import React, { useContext, useEffect, useState } from 'react'
import LogosContext from "app/react/components/logos/LogosContext";
import Files from "app/react/components/logos/Files";
import useHoverContent from 'app/react/hooks/useHoverContent'

export default function LogoPackages () {

  const { selectedOption, primaryLogoWeb, primaryLogoPrint, logoPackageTitle, logoPackageText, buttonTexts, files } = useContext(LogosContext)
  const [logo, setLogo] = useState(primaryLogoWeb)

  useEffect(() => {
    setLogo(getLogo())
  }, [selectedOption])

  const getLogo = () => {
    if (selectedOption === 'web') {
      return primaryLogoWeb
    }
    return primaryLogoPrint
  }

  const { hoverClass, hoverContent } = useHoverContent({
    url: logo ? logo.url : '',
    copyText: buttonTexts.copy,
    downloadText: buttonTexts.download
  })

  if (logo === null && files.length === 0) {
    return
  }

  return (
    <div className="dm-image-text">
      <div className={'dm-image-text__image-container ' + hoverClass}>
        {logo && (<>
          <img src={logo.url} alt={logo.alt}/>
          {hoverContent()}
        </>)}
      </div>
      <div className="dm-image-text__text-container">
        {logoPackageTitle && (
          <h3 className="dm-image-text__title dm-title">{logoPackageTitle}</h3>
        )}
        {logoPackageText && (
          <div className="dm-image-text__text dm-wysiwyg dm-wysiwyg--fs14">{logoPackageText}</div>
        )}
        <Files files={files} />
      </div>
    </div>
  )
}